import styled from 'styled-components';

export const StyledContainer = styled.div`
  border-radius: 5px;
  box-shadow: inset 0 0 0 2px var(--border-D, #3E475A);
`;
